import React, {PureComponent} from 'react';
import { Link } from 'react-router-dom';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Table,
} from 'reactstrap';
import _ from 'lodash';

import './styles.css';
import axios from "axios";
import Util from '../../Common/util';
import API from '../../Common/api';

class PrintPutawayDetail extends PureComponent {
  

  constructor(props) {
    /*var today = new Date(),
            date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();*/

  var tempDate = new Date();
  var date = tempDate.getFullYear() + '-' + (tempDate.getMonth()+1) + '-' + tempDate.getDate() +' '+ tempDate.getHours()+':'+ tempDate.getMinutes()+':'+ tempDate.getSeconds();
  const currDate = date;
    super(props);
    this.onLogin = this.onLogin.bind(this);
    this.prinData = this.prinData.bind(this);
    this.state = {
      showPassword: false,
      showPrintData: [],
      date: currDate
    };

    this.showPassword = this.showPassword.bind(this);
  }

  showPassword(e) {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  }

  componentDidMount(){
   var printDetail_data = localStorage.getItem('printData');
    var printDetails = JSON.parse(printDetail_data);
   /* console.log(printDetail_data);*/
    /*this.setState({
      showPrintData: printDetails
    })*/

    this.state.showPrintData.push(printDetails);
    
    

    setTimeout(this.prinData ,1100 );

    /*if (window.location.href="/putaway/printPutaway") {
          window.location.reload();
        }*/
   
  }

  prinData(){
   /* for (var i = 0; i < this.state.printDetails.length; i++) {*/
      window.print();
      
    /*}*/

    
  }

  onLogin(){
    const payload = {
    
    };
  
  
  API.post('/auth/oauth2/login', { param: payload })
      
      .then((response) =>  {

        console.log(response.data.login);
        if (response.data.login === false) {
          window.location.href = response.data.url;
        }

      })
      .catch(function (error) {
        
        
        
      });

  }




  render() {
    const { handleSubmit } = this.props;
    //   const { showPassword } = this.state;
    const arrData= JSON.parse(localStorage.getItem("printData"));
    const arrayValue= [];
    arrayValue.push(arrData);
    console.log(arrayValue);
    console.log(arrayValue.sort());





    

    return (






    <div className="print_table" style={{padding: 15}}>


    {
                       
          arrayValue.map((item) => (
            _.map(item, (value, key) => (
              <div style={{width: '100%'}}>
                <div className="separater" style={{marginBottom: 20, borderBottomWidth: 1}}>
                  <h5 style={{width: '50%', float: 'left', marginBottom: 15}}> <span style={{fontWeight: 'bold'}}> User Name: </span> <span> {key} </span> </h5>
                  <h5 style={{width: '50%', float: 'left', textAlign: 'right', marginBottom: 15}}> <span style={{fontWeight: 'bold'}}> Date: </span> <span> {this.state.date} </span></h5>
                  <h5 style={{width: '50%', float: 'left', marginBottom: 15}}> <span style={{fontWeight: 'bold'}}> GRN Number: </span> <span> {value[0].grnNumber} / </span> <span style={{fontWeight: 'bold'}}> GRN Line Number: </span> <span> {value[0].gnrLineNumber} </span> </h5>
                  <Table responsive className="table table--bordered" style={{marginBottom: 50}}>
                     <thead style={{background: '#ccc'}}>
                      <tr>
                        <th>BIN Id</th>
                        <th> Zone Name </th>

                        {value[0].tester === false && (
                            <th>Product Code</th>   
                        )}
                        <th> MRP </th>                   
                        <th> Product Name </th>
                        <th> Batch</th>
                        <th> PKD </th>
                        <th> UPC </th>
                        <th> Outer Qty </th>
                        <th> Inner Qty </th>
                        <th> Each Qty </th>
                        <th> Crate/Loc </th>
                       {/* <th> CBU </th>*/}

                       {/* {value[0].tester === false && (
                         <th> PKD </th>
                        )}

                        {value[0].tester === false && (
                         <th> MRP </th>
                        )}

                        {value[0].tester === false && (
                         <th> UPC </th>
                        )}*/}
                        {/*{((value[0].salesReturn === true) || (value[0].documentType.toLowerCase() == "outer carton")) && (
                          <th> EAN </th>
                        )}

                        {((value[0].tester === false && value[0].salesReturn === true)  || (value[0].documentType.toLowerCase() == "outer carton")) && (
                        
                        <th>Loose Quantity(pcs) </th>
                        )}

                        {value[0].tester === true && (
                        <th>Tester Quantity(pcs) </th>
                        )}*/}

                       
                        
                        
                        
                        


                        
                      </tr>
                    </thead>
                    <tbody>
                      {value.map(insideItem => (
                        <tr>
                          <td>{insideItem.binId}</td>
                          <td> {insideItem.zoneName}</td>

                          {insideItem.tester === false && (

                            <td>{insideItem.sku7Code} </td>
                          )}
                          <td> {insideItem.mrp}</td>

                          <td>{insideItem.lbSkuProductName} </td>
                          <td> {insideItem.batch}</td> 
                        <td>{insideItem.pkd} </td>
                         <td>{insideItem.upc} </td>
                        <td>{insideItem.outerQty}</td>
                        <td>{insideItem.receivedIcldQty}</td>

                        <td>{insideItem.looseQuantity}</td>


                         {/* {insideItem.tester === false && (

                          <td> {insideItem.pkd} </td>
                          

                          )}


                          {insideItem.tester === false && (

                          <td> {insideItem.mrp} </td>
                          

                          )}


                          {insideItem.tester === false && (

                          <td> {insideItem.upc} </td>
                          

                          )}*/}

                         {/* {insideItem.tester === true && (

                          <td> {insideItem.basepackCode} </td>
                          

                          )}
*/}

                          {/*<td> {insideItem.pkd} </td>
                          <td> {insideItem.mrp} </td>
                          <td> {insideItem.upc} </td>*/}

                          {/*{((insideItem.tester === false && insideItem.salesReturn === false) && (insideItem.documentType.toLowerCase() != "outer carton")) &&(

                          <td> {insideItem.receivedIcldQty} </td>
                          

                          )}

                          {((insideItem.salesReturn === true)  || (insideItem.documentType.toLowerCase() == "outer carton")) && (
                            <td> {insideItem.ean} </td>
                          )}

                          {((insideItem.tester === false && insideItem.salesReturn === true )  || (insideItem.documentType.toLowerCase() == "outer carton")) && (

                          
                          <td> {insideItem.looseQuantity} </td>

                          )}

                    

                          {insideItem.tester === true && (

                          
                          <td> {insideItem.testerQty} </td>

                          )}*/}
                          


                         
                         
                          <td> {insideItem.crateId}</td>
                          
                        </tr>
                      ))}

                    </tbody>
              
                  </Table>
                  

                </div>

                <div className="page-break"> </div>

                
                
              </div>

            ))
          ))
        }




</div>

)
}

}



export default PrintPutawayDetail;